const algoliasearch = require('algoliasearch/lite')
const instantsearch = require('instantsearch.js').default

import { searchBoxCatalog } from '../widgets/algolia/SearchBoxCatalog'
import { catalogSearchHits } from '../widgets/algolia/CatalogSearchHits'
import { catalogConfigure } from '../widgets/algolia/CatalogConfigure'

export default class AlgoliaSearchCatalog {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.appId = window.agI
    this.apiKey = window.agSk
    this.index = window.agSc
    this.env = window.Environment
    this.hideNoResults = this.el.querySelectorAll('[data-hide-no-results]')
  }

  init() {
    if (!this.check()) {
      return false
    }
    // only log analytics if in production
    const analytics = this.env === 'production'
    const algoliaClient = algoliasearch(this.appId, this.apiKey)
    const noResults = this.hideNoResults
    noResults.forEach((element) => {
      element.classList.remove('hidden')
    })

    const searchClient = {
      search(requests) {
        if (requests.every(({ params }) =>
          !params.query)) {
          return Promise.resolve({
            results: requests.map(() =>
              ({
                hits: [],
                nbHits: 0,
                nbPages: 0,
              })),
          })
        }
        return algoliaClient.search(requests)
      },
    }

    const search = instantsearch({
      indexName: this.index,
      analytics,
      searchFunction(helper) {
        if (helper.state.query === '') {
          noResults.forEach((element) => {
            element.style.display = 'none'
          })
        } else {
          noResults.forEach((element) => {
            element.style.display = ''
          })
        }

        helper.search()
      },
      searchClient,
    })

    search.addWidgets([
      catalogConfigure,
      searchBoxCatalog,
      catalogSearchHits,
    ])
    search.start()
  }

  check() {
    return true
  }
}
